/* eslint-env browser */

(function (window, document) {
  document.getElementById('subscribe-form').addEventListener('submit', function (e) {
    e.preventDefault();

    var pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var email = e.target.querySelector('#subscribe-form input[name=email]').value;
    email = email.replace(/^\s+|\s+$/g, '');

    if (!pattern.test(email)) {
      document.querySelector('.subscribe-form-message').innerHTML = 'Please enter valid email address.';
    } else {
      fetch('/xhr/email/subscribe', { method: 'POST', body: JSON.stringify({ email: email }) }).then(() => {
        document.querySelector('.subscribe-form-message').innerHTML = 'Thank you for subscribing!';
      })
    }
  });
})(window, document);
